<div
  [style.z-index]="index + 50"
  class="fixed bottom-0 left-0 right-0 top-0 h-screen"
>
  <div
    (click)="onClicked($event)"
    (keydown.escape)="onClicked($event)"
    [ngClass]="{
      'backdrop-blur': withBackdrop,
      'absolute inset-0 h-screen w-screen': true,
    }"
  ></div>
  <div
    class="dynamicHeight pointer-events-none relative w-screen"
    style="padding-bottom: env(safe-area-inset-bottom, 32px) !important"
  >
    <ng-content></ng-content>
  </div>
</div>
